module.exports = __webpack_public_path__ + "static/hero-webinar-cb4632cfb59ac258205908e10cbd5a5c.svg";